module.exports = __webpack_public_path__ + "static/media/stone_-1.727fddaf.svg";